import RequestDataExportModal from './components/RequestDataExportModal';
import ErasureRequest from './models/ErasureRequest';
import Export from './models/Export';

export default {
  'gdpr/models/ErasureRequest': ErasureRequest,
  'gdpr/models/Export': Export,
  'gdpr/components/RequestDataExportModal': RequestDataExportModal,
};
